import $ from "jquery";

const loginModalShown = function () {
  $("#customer_email").focus();
};

$(document).on("turbolinks:load", function () {
  // Replace log in link href to make modal work
  $("#nav_log_in").attr("href", "#");
  $("#loginModal").on("shown.bs.modal", loginModalShown);
});
